<div class="faqs article-bg">
  <div class="sub-heading"><h2>Frequently Asked Questions</h2></div>
  <div class="container">
    <div class="support-faq-content">
      <div class="support-faq-item" *ngFor="let faq of faqs; let id = index">
        <div class="title" (click)="onClickedFaq(id)" [ngClass]="{'active': selectedFaq === id}">
          {{ faq.q }}
          <svg [ngClass]="{'active': selectedFaq === id}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.19 29.19"><defs><style>.arrow-right{fill:inherit;stroke:none;}</style></defs><title>arrow-right</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="arrow-right" d="M14.6,29.19a14.6,14.6,0,1,1,14.59-14.6A14.62,14.62,0,0,1,14.6,29.19ZM14.6,1a13.6,13.6,0,0,0,0,27.19h0A13.6,13.6,0,0,0,14.6,1Z"/><path class="arrow-right" d="M13.07,19.73a1,1,0,0,1-.76-.35A1,1,0,0,1,12.42,18l4-3.38-4-3.37a1,1,0,0,1-.11-1.41,1,1,0,0,1,1.4-.12l4.88,4.14a1,1,0,0,1,0,1.53L13.71,19.5A1,1,0,0,1,13.07,19.73Z"/></g></g></svg>
        </div>
        <div class="content" [innerHTML]="faq.a"></div>
      </div>
      <p class="ion-text-center"><strong><a href="/faqs">See here</a> for more Help & Support questions</strong></p>
    </div>
  </div>
</div>